import Body from './Body';
import Header from './Header';

const ManufacturerItem = {
  Header,
  Body,
};

export default ManufacturerItem;
